import { PageBannerComponent } from "../../components/page-banner/page-banner.component";
import { Component, Inject, OnInit, Renderer2, DOCUMENT } from '@angular/core';

import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { MediaArticlesComponent } from "../../components/media-articles/media-articles.component";
@Component({
  selector: 'app-media-corner',
  imports: [PageBannerComponent, MediaArticlesComponent],
  templateUrl: './media-corner.component.html',
  styleUrl: './media-corner.component.scss'
})
export class MediaCornerComponent {
  private metaDataSet = false;
  constructor(private readonly meta: Meta,
    private readonly title: Title, private readonly route: ActivatedRoute,
    private readonly renderer: Renderer2,
    @Inject(DOCUMENT) private readonly document: Document
  ) { }

  dataContent: any = [
    {
      'category': ['All', 'Online', 'Video', 'Print', 'Press release'],
      'subContent': false,
      'batch': true,
    },
    {
      'categoryData': [

        {
          "mediaType": "Online",
          "image_url": "/assets/images/media/online/online-img-32.webp",
          "batch": "<span>Online Coverage</span>Money Control",
          "title": "Daily Voice: Good monsoon, tamed inflation may give RBI MPC room to cut rates, says Shriram Wealth's Vikas Satija",
          "btnText": "Read More",
          "link": "https://www.moneycontrol.com/news/business/markets/daily-voice-good-monsoon-tamed-inflation-may-give-rbi-mpc-room-to-cut-rates-says-shriram-wealth-s-vikas-satija-13589141.html",
          "date": "15/09/2025"
        },
        {

          "mediaType": "Video",
          "image_url": "/assets/images/media/online/Video-1.webp",
          "batch": "<span>Podcast</span>EB Capital",
          "title": "Where to Invest in India (2025 &amp; Beyond) | Podcast with Vikas Satija",
          "alt_text": "Ultra",
          "btnText": "Read More",
          "link": "https://www.youtube.com/embed/QwlPyrFXyh0?autoplay=1&mute=1"
        },
        {

          "mediaType": "Video",
          "image_url": "/assets/images/media/online/Video-2.webp",
          "batch": "<span>Podcast</span>Simple Hai!",
          "title": "How To Build Wealth That Lasts? | Vikas Satija, MD &amp; CEO of Shriram Wealth Breaks It All Down",
          "alt_text": "Ultra",
          "btnText": "Read More",
          "link": "https://www.youtube.com/embed/2ihM6wuqEWI?autoplay=1&mute=1"
        },
        {
          "mediaType": "Print",
          "image_url": "/assets/images/Print-1.webp",
          "batch": "<span>Print</span> The Free Press Journal",
          "title": "'Build Wealth That Lasts' The Road To Fortune",
          "alt_text": "'Build Wealth That Lasts' The Road To Fortune",
          "btnText": "Read More",
          "link": "/assets/pdf/print-media.pdf",
          "date": "09/08/2025"
        },
        {
          "mediaType": "Online",
          "image_url": "/assets/images/media/online/online-img-31.webp",
          "batch": "<span>Online Coverage</span>Money Control",
          "title": "Shriram Wealth bets on 'democratising' wealth, to soon enter Rs 10 lakhs-Rs 2 crore segment",
          "btnText": "Read More",
          "link": "https://www.moneycontrol.com/news/business/companies/shriram-wealth-bets-on-democratising-wealth-to-soon-enter-rs-10-lakhs-rs-2-crore-segment-13549850.html",
          "date": "15/09/2025"
        },
        {
          "mediaType": "Online",
          "image_url": "/assets/images/media/online/online-img-30.webp",
          "batch": "<span>Online Coverage</span>Economic Times",
          "title": "GST 2.0 and ripple effect on luxury, investments, and wealth planning",
          "btnText": "Read More",
          "link": "https://economictimes.indiatimes.com/markets/stocks/news/gst-2-0-and-ripple-effect-on-luxury-investments-and-wealth-planning/articleshow/123878639.cms?from=mdr",
          "date": "15/09/2025"
        },
        {

          "mediaType": "Video",
          "image_url": "/assets/images/media/online/BFSI.webp",
          "batch": "<span>ONLINE COVERAGE</span>ET BFSI",
          "title": "India’s organised wealth to grow 8x by 2047, massive scope for new players: Shriram Wealth CEO",
          "alt_text": "Ultra",
          "btnText": "Read More",
          "link": "https://www.youtube.com/embed/ck_KIxmxyGk?autoplay=1&mute=1"
        },
        {
          "mediaType": "Online",
          "image_url": "/assets/images/media/online/online-img-29.webp",
          "batch": "<span>Online Coverage</span>BW",
          "title": "India’s Wealth Landscape Is Shifting — Are Your Financial Habits Evolving Too?",
          "btnText": "Read More",
          "link": "https://www.businessworld.in/article/indias-wealth-landscape-is-shifting-are-your-financial-habits-evolving-too-570512",
          "date": "08/09/2025"
        },
        {
          "mediaType": "Online",
          "image_url": "/assets/images/media/online/online-img-28.webp",
          "batch": "<span>Online Coverage</span>ETCIO",
          "title": "Beyond the dashboard: Personalization through data in wealth management",
          "btnText": "Read More",
          "link": "https://cio.economictimes.indiatimes.com/news/artificial-intelligence/unlocking-wealth-management-the-power-of-hyper-personalization-and-ai/123625414?utm_source=portal_category_widget&utm_medium=homepage",
          "date": "01/09/2025"
        },
        {
          "mediaType": "Online",
          "image_url": "assets/images/media/online/online-img-2.webp",
          "batch": "<span>Online Coverage</span>TechCircle",
          "title": "Shriram Wealth’s CTO on tech strategy, balancing innovation, and compliance cost",
          "btnText": "Read More",
          "link": "https://www.techcircle.in/2025/08/18/shriram-wealth-s-cto-on-tech-strategy-balancing-innovation-and-compliance-cost",
          "date": "18/08/2025"
        },
        {
          "mediaType": "Online",
          "image_url": "/assets/images/media/online/online-img-26.webp",
          "batch": "<span>Online Coverage</span>The New Indian Express",
          "title": "Only 15% of wealth in India is formally managed: Vikas Satija of Shriram Wealth",
          "btnText": "Read More",
          "link": "https://www.newindianexpress.com/business/2025/Aug/11/only-15-of-wealth-in-india-is-formally-managed-vikas-satija-of-shriram-wealth",
          "date": "12/08/2025"
        },
        {
          "mediaType": "Print",
          "image_url": "/assets/images/media/blog-51.webp",
          "batch": "<span>Print</span> Andhra Jyoti",
          "title": "Shriram Wealth signs agreement with Roundtable India",
          "alt_text": "Shriram Wealth signs agreement with Roundtable India",
          "btnText": "Read More",
          "link": "/assets/images/pdf/blog-51.pdf",
          "date": "09/08/2025"
        },
        {
          "mediaType": "Print",
          "image_url": "/assets/images/media/blog-52.webp",
          "batch": "<span>Print</span> Mathrubhumi",
          "title": "Shriram Wealth to collaborate with Roundtable",
          "alt_text": "Shriram Wealth to collaborate with Roundtable",
          "btnText": "Read More",
          "link": "/assets/images/pdf/blog-52.pdf",
          "date": "08/08/2025"
        },
        {
          "mediaType": "Online",
          "image_url": "/assets/images/media/online/online-img-27.webp",
          "batch": "<span>Online Coverage</span>The Finance Outlook India",
          "title": "Shriram Wealth Partners with Round Table India for Financial Literacy, Philanthropic Initiatives",
          "btnText": "Read More",
          "link": "https://www.financeoutlookindia.com/news/shriram-wealth-partners-with-round-table-india-for-financial-literacy-philanthropic-initiatives-nwid-5846.html",
          "date": "07/08/2025"
        },

        {
          "mediaType": "Online",
          "image_url": "/assets/images/media/online/online-img-12.webp",
          "batch": "<span>Online Coverage</span>THE ECONOMIC TIMES",
          "title": "ETMarkets Smart Talk | Festive demand, monsoon could lift markets in 2H-2025: Shriram Wealth CEO",
          "btnText": "Read More",
          "link": "https://economictimes.indiatimes.com/markets/expert-view/etmarkets-smart-talk-festive-demand-monsoon-could-lift-markets-in-h2fy25-shriram-wealth-ceo/articleshow/122831015.cms?from=mdr",
          "date": "28/07/2025"
        },
        {
          "mediaType": "Print",
          "image_url": "/assets/images/media/blog-47.webp",
          "batch": "<span>Print</span> The Times of India",
          "title": "Legacy companies pan focus on financial services for affluent, HNIs and UHNIs",
          "alt_text": "Legacy companies pan focus on financial services for affluent, HNIs and UHNIs",
          "btnText": "Read More",
          "link": "/assets/images/pdf/blog-47.pdf",
          "date": "10/07/2025"
        },
        {
          "mediaType": "Online",
          "image_url": "/assets/images/media/online/online-img-26.webp",
          "batch": "<span>Online Coverage</span>FE BFSI",
          "title": "5 Trends that will Shape Wealth Management Industry in India Ahead",
          "btnText": "Read More",
          "link": "https://bfsi.financialexpress.com/blogs/5-trends-that-will-shape-wealth-management-industry-in-india-ahead",
          "date": "02/07/2025"
        },
        {
          "mediaType": "Print",
          "image_url": "/assets/images/media/blog-46.webp",
          "batch": "<span>Print</span> The Hindu",
          "title": "Investors like to buy many financial products under one umbrella: Satija",
          "alt_text": "Investors like to buy many financial products under one umbrella: Satija",
          "btnText": "Read More",
          "link": "/assets/images/pdf/blog-46.pdf",
          "date": "22/06/2025"
        },
        {
          "mediaType": "Print",
          "image_url": "/assets/images/media/blog-45.webp",
          "batch": "<span>Print</span> Divya Bhaskar (Gujarati)",
          "title": "Joint venture to popularize wealth management",
          "alt_text": "Joint venture to popularize wealth management",
          "btnText": "Read More",
          "link": "/assets/images/pdf/blog-45.pdf",
          "date": "22/06/2025"
        },
        {
          "mediaType": "Print",
          "image_url": "/assets/images/media/blog-44.webp",
          "batch": "<span>Print</span> The Sunday Standard",
          "title": "Shriram Group, Sanlam JV to float wealth venture",
          "alt_text": "Shriram Group, Sanlam JV to float wealth venture",
          "btnText": "Read More",
          "link": "/assets/images/pdf/blog-44.pdf",
          "date": "22/06/2025"
        },
        {
          "mediaType": "Print",
          "image_url": "/assets/images/media/blog-43.webp",
          "batch": "<span>Print</span> The Hindu Business Line",
          "title": "Shriram Wealth sees potential in emerging affluent segment",
          "alt_text": "Shriram Wealth sees potential in emerging affluent segment",
          "btnText": "Read More",
          "link": "/assets/images/pdf/blog-43.pdf",
          "date": "21/06/2025"
        },
        {
          "mediaType": "Print",
          "image_url": "/assets/images/media/blog-42.webp",
          "batch": "<span>Print</span> Dina Malar (Tamil)",
          "title": "Shriram Group Launches Shriram Wealth",
          "alt_text": "Shriram Group Launches Shriram Wealth",
          "btnText": "Read More",
          "link": "/assets/images/pdf/blog-42.pdf",
          "date": "21/06/2025"
        },
        // New online
        {
          "mediaType": "Online",
          "image_url": "/assets/images/media/online/online-img-1.webp",
          "batch": "<span>Online Coverage</span>Cafe Mutual",
          "title": "Shriram ties up with South Africa's Sanlam to launch wealth management business",
          "btnText": "Read More",
          "link": "https://cafemutual.com/news/cafe-alt/35110-shriram-ties-up-with-south-africas-sanlam-to-launch-wealth-management-business",
          "date": "19/06/2025"
        },

        {
          "mediaType": "Print",
          "image_url": "/assets/images/media/blog-41.webp",
          "batch": "<span>Print</span> Loksatta (Marathi)",
          "title": "Shriram Wealth targets assets worth Rs 50,000 crore in five years",
          "alt_text": "Shriram Wealth targets assets worth Rs 50,000 crore in five years",
          "btnText": "Read More",
          "link": "/assets/images/pdf/blog-41.pdf",
          "date": "18/06/2025"
        },
        {
          "mediaType": "Print",
          "image_url": "/assets/images/media/blog-40.webp",
          "batch": "<span>Print</span> Sakal (Marathi)",
          "title": "Shriram Wealth company launched",
          "alt_text": "Shriram Wealth company launched",
          "btnText": "Read More",
          "link": "/assets/images/pdf/blog-40.pdf",
          "date": "17/06/2025"
        },
        {
          "mediaType": "Print",
          "image_url": "/assets/images/media/blog-39.webp",
          "batch": "<span>Print</span> Deccan Herald",
          "title": "Bluru HNIs, UHNIs lead In alternate investment",
          "alt_text": "Bluru HNIs, UHNIs lead In alternate investment",
          "btnText": "Read More",
          "link": "/assets/images/pdf/blog-39.pdf",
          "date": "17/06/2025"
        },
        {
          "mediaType": "Print",
          "image_url": "/assets/images/media/blog-50.webp",
          "batch": "<span>Print</span> Mathrubhumi (Malayalam)",
          "title": "Shriram Group launches wealth management company",
          "alt_text": "Shriram Group launches wealth management company",
          "btnText": "Read More",
          "link": "/assets/images/pdf/blog-50.pdf",
          "date": "15/06/2025"
        },
        {
          "mediaType": "Online",
          "image_url": "/assets/images/media/online/online-img-2.webp",
          "batch": "<span>Online Coverage</span>loksatta.com",
          "title": "‘श्रीराम वेल्थ’चे पाच वर्षात ५०,००० कोटी मालमत्तेचे लक्ष्य, ‘सनलॅम’शी भागीदारीतून संयुक्त उपक्रम",
          "btnText": "Read More",
          "link": "https://www.loksatta.com/business/finance/shriram-wealth-targets-rs-50000-crore-in-assets-in-five-years-joint-venture-in-partnership-with-sanlam-print-eco-news-asj-82-5156022/",
          "date": "14/06/2025"

        },

        {
          "mediaType": "Print",
          "image_url": "/assets/images/media/blog-38.webp",
          "batch": "<span>Print</span> Vyapar (Gujarati)",
          "title": "Shriram Group's wealth management company joins hands with Sanlam Group",
          "alt_text": "Shriram Group's wealth management company joins hands with Sanlam Group",
          "btnText": "Read More",
          "link": "/assets/images/pdf/blog-38.pdf",
          "date": "14/06/2025"
        },

        {
          "mediaType": "Print",
          "image_url": "/assets/images/media/blog-5.webp",
          "batch": "<span>Print</span>The Hindu",
          "title": "Shriram Group, Sanlam foray into wealth management JV",
          "alt_text": "Shriram Group, Sanlam foray into wealth management JV",
          "btnText": "Read More",
          "link": "/assets/images/pdf/blog-5.pdf",
          "date": "13/06/2025"
        },
        {
          "mediaType": "Print",
          "image_url": "/assets/images/media/blog-6.webp",
          "batch": "<span>Print</span>The Economic Times",
          "title": "Shriram Grp, Sanlam Ink Wealth Mgmt JV",
          "alt_text": "Shriram Grp, Sanlam Ink Wealth Mgmt JV",
          "btnText": "Read More",
          "link": "/assets/images/pdf/blog-6.pdf",
          "date": "13/06/2025"
        },
        {
          "mediaType": "Print",
          "image_url": "/assets/images/media/blog-7.webp",
          "batch": "<span>Print</span>Business Standard",
          "title": "Shriram group enters wealth management space via Sanlam JV",
          "alt_text": "Shriram group enters wealth management space via Sanlam JV",
          "btnText": "Read More",
          "link": "/assets/images/pdf/blog-7.pdf",
          "date": "13/06/2025"
        },
        {
          "mediaType": "Print",
          "image_url": "/assets/images/media/blog-9.webp",
          "batch": "<span>Print</span>Mint",
          "title": "Sanlam sharpens India focus with JV",
          "alt_text": "Sanlam sharpens India focus with JV",
          "btnText": "Read More",
          "link": "/assets/images/pdf/blog-9.pdf",
          "date": "13/06/2025"
        },
        {
          "mediaType": "Print",
          "image_url": "/assets/images/media/blog-10.webp",
          "batch": "<span>Print</span>The Hindu Business Line",
          "title": "Shriram Group enters wealth management, forms 50:50 joint venture with Sanlam",
          "alt_text": "Shriram Group enters wealth management, forms 50:50 joint venture with Sanlam",
          "btnText": "Read More",
          "link": "/assets/images/pdf/blog-10.pdf",
          "date": "13/06/2025"
        },
        {
          "mediaType": "Print",
          "image_url": "/assets/images/media/blog-11.webp",
          "batch": "<span>Print</span>Deccan Chronicle",
          "title": "Shriram Group co announces new joint venture",
          "alt_text": "Shriram Group co announces new joint venture",
          "btnText": "Read More",
          "link": "/assets/images/pdf/blog-11.pdf",
          "date": "13/06/2025"
        },
        {
          "mediaType": "Print",
          "image_url": "/assets/images/media/blog-13.webp",
          "batch": "<span>Print</span>Sakshi (Telugu)",
          "title": "Shri Ram group wealth services",
          "alt_text": "Shri Ram group wealth services",
          "btnText": "Read More",
          "link": "/assets/images/pdf/blog-13.pdf",
          "date": "13/06/2025"
        },
        {
          "mediaType": "Print",
          "image_url": "/assets/images/media/blog-8.webp",
          "batch": "<span>Print</span>Financial Express",
          "title": "Shriram plans foray into alternate investment space",
          "alt_text": "Shriram plans foray into alternate investment space",
          "btnText": "Read More",
          "link": "/assets/images/pdf/blog-8.pdf",
          "date": "13/06/2025"
        },
        {
          "mediaType": "Online",
          "image_url": "/assets/images/media/online/online-img-3.webp",
          "batch": "<span>Online Coverage</span>The Financial Express",
          "title": "Shriram plans foray into alternate investment space",
          "btnText": "Read More",
          "link": "https://www.financialexpress.com/business/industry-shriram-plans-foray-into-alternate-investment-space-3878052/",
          "date": "13/06/2025"
        },
        {
          "mediaType": "Online",
          "image_url": "/assets/images/media/online/online-img-4.webp",
          "batch": "<span>Online Coverage</span>Gujarati News",
          "title": "શ્રીરામ ગ્રુપની વેલ્થ મૅનેજમેન્ટ કંપનીએ સેનલેમ ગ્રુપ સાથે હાથ મિલાવ્યા",
          "btnText": "Read More",
          "link": "https://www.janmabhoominewspapers.com/news/vyapar/23776",
          "date": "13/06/2025"
        },
        {
          "mediaType": "Online",
          "image_url": "/assets/images/media/online/online-img-6.webp",
          "batch": "<span>Online Coverage</span>Marca Money",
          "title": "Shriram Group partners with South Africas Sanlam Group to launch Shriram Wealth",
          "btnText": "Read More",
          "link": "https://www.marcamoney.com/shriram-group-partners-with-south-africas-sanlam-group-to-launch-shriram-wealth/",
          "date": "13/06/2025"
        },
        {
          "mediaType": "Online",
          "image_url": "/assets/images/media/online/online-img-7.webp",
          "batch": "<span>Online Coverage</span>CityWire",
          "title": "Round up: Launches and hires in India's booming wealth market",
          "btnText": "Read More",
          "link": "https://citywire.com/asia/news/round-up-launches-and-hires-in-indias-booming-wealth-market/a2467847",
          "date": "13/06/2025"
        },
        {
          "mediaType": "Online",
          "image_url": "/assets/images/media/online/online-img-8.webp",
          "batch": "<span>Online Coverage</span>The Hindu",
          "title": "Shriram Group forays into wealth management through joint venture with Sanlam",
          "btnText": "Read More",
          "link": "https://www.thehindu.com/incoming/shriram-group-forays-into-wealth-management-through-joint-venture-with-sanlam/article69687510.ece",
          "date": "12/06/2025"
        },
        {
          "mediaType": "Online",
          "image_url": "/assets/images/media/online/online-img-9.webp",
          "batch": "<span>Online Coverage</span>Prahaar",
          "title": "'प्रहार' Exclusive:श्रीराम समुहाने सनलाम समुहासोबत केली धोरणात्मक भागीदारी 'श्रीराम वेल्थ' ब्रँड भारतात लॉन्च",
          "btnText": "Read More",
          "link": "https://prahaar.in/2025/06/12/prahaar-exclusive-shriram-group-enters-into-strategic-partnership-with-sanlam-group-to-launch-shriram-wealth-brand-in-india/",
          "date": "12/06/2025"
        },
        {
          "mediaType": "Online",
          "image_url": "/assets/images/media/online/online-img-12.webp",
          "batch": "<span>Online Coverage</span>europesays",
          "title": "South Africa’s Sanlam sharpens India focus with Shriram wealth management JV",
          "btnText": "Read More",
          "link": "https://www.europesays.com/2157341/",
          "date": "12/06/2025"
        },
        {
          "mediaType": "Online",
          "image_url": "/assets/images/media/online/online-img-13.webp",
          "batch": "<span>Online Coverage</span>hotscup",
          "title": "Shriram Group ka Dhamaka: Naya Wealth Venture! ????",
          "btnText": "Read More",
          "link": "https://hotscup.com/shriram-group-ka-dhamaka-naya-wealth-venture-%f0%9f%92%b0/",
          "date": "12/06/2025"
        },
        {
          "mediaType": "Online",
          "image_url": "/assets/images/media/online/online-img-14.webp",
          "batch": "<span>Online Coverage</span>ET Realty",
          "title": "Game-Changer: Shriram Properties Launches South Punes First Downtown in Undri",
          "btnText": "Read More",
          "link": "https://realty.economictimes.indiatimes.com/news/brand-connect-initiative/shriram-properties-unveils-punes-first-downtown-in-undri-transforming-real-estate/121803905",
          "date": "12/06/2025"
        },

        {
          "mediaType": "Online",
          "image_url": "/assets/images/media/online/online-img-16.webp",
          "batch": "<span>Online Coverage</span>The Hindu Business Line",
          "title": "Shriram Wealth debuts, targets ₹50,000 cr Asset Under Advice over 5 years",
          "btnText": "Read More",
          "link": "https://www.thehindubusinessline.com/money-and-banking/shriram-wealth-debuts-targets-50000-cr-asset-under-advice-over-5-years/article69686400.ece",
          "date": "12/06/2025"
        },
        {
          "mediaType": "Online",
          "image_url": "/assets/images/media/online/online-img-17.webp",
          "batch": "<span>Online Coverage</span>Moneycontrol",
          "title": "Shriram Group launches wealth management arm in partnership with Sanlam Group",
          "btnText": "Read More",
          "link": "https://www.moneycontrol.com/news/business/markets/shriram-group-launches-wealth-management-arm-in-partnership-with-sanlam-group-13113197.html",
          "date": "12/06/2025"
        },
        {
          "mediaType": "Online",
          "image_url": "/assets/images/media/online/online-img-18.webp",
          "batch": "<span>Online Coverage</span>Business Today",
          "title": "Shriram Group &amp; South Africas Sanlam Group join hands to launch Shriram Wealth with 50:50 JV",
          "btnText": "Read More",
          "link": "https://www.businesstoday.in/personal-finance/investment/story/shriram-group-south-africas-sanlam-group-join-hands-to-launch-shriram-wealth-with-5050-jv-480228-2025-06-12",
          "date": "12/06/2025"
        },
        {
          "mediaType": "Online",
          "image_url": "/assets/images/media/online/online-img-15.webp",
          "batch": "<span>Online Coverage</span>Mint",
          "title": "South Africas Sanlam sharpens India focus with Shriram wealth management JV",
          "btnText": "Read More",
          "link": "https://www.livemint.com/industry/south-africa-sanlam-shriram-wealth-nagpur-coimbatore-economy-growth-11749726133058.html",
          "date": "12/06/2025"
        },
        {
          "mediaType": "Online",
          "image_url": "/assets/images/media/online/online-img-21.webp",
          "batch": "<span>Online Coverage</span>Startup News",
          "title": "Shriram Group Launches Shriram Wealth, a Strategic 50:50 Joint Venture with Sanlam Group",
          "btnText": "Read More",
          "link": "https://startupnews.fyi/2025/06/12/shriram-group-launches-shriram-wealth-a-strategic-5050-joint-venture-with-sanlam-group/",
          "date": "12/06/2025"
        },
        {
          "mediaType": "Online",
          "image_url": "/assets/images/media/online/online-img-23.webp",
          "batch": "<span>Online Coverage</span>MSN India",
          "title": "Not giving Sanlam more than 50% stake in Shriram Wealth, says Shriram Capital CEO",
          "btnText": "Read More",
          "link": "https://www.msn.com/en-in/money/markets/not-giving-sanlam-more-than-50-stake-in-shriram-wealth-says-shriram-capital-ceo/ar-AA1GzFRV",
          "date": "12/06/2025"
        },
        // Video

        {

          "mediaType": "Video",
          "image_url": "/assets/images/media/thumbnail1.webp",
          "batch": "<span>Online Coverage</span>CNBC TV18",
          "title": "Shriram Group & Sanlam to invest Rs.200 Crore in Shriram Wealth.",
          "subText": "Chennai-based Shriram Group and South Africa’s Sanlam have announced plans to invest ₹200 crore in their newly formed 50:50 joint venture—Shriram Wealth...",
          "alt_text": "CNBC TV18",
          "btnText": "Read More",
          "link": "https://www.youtube.com/embed/SCcyAVpbuw4?autoplay=1&si=s_XK8SmjsB3OQwFo"
        },
        {

          "mediaType": "Video",
          "image_url": "/assets/images/media/online/online-img-12.webp",
          "batch": "<span>Podcast</span>Ultra",
          "title": "Shriram Group 50 year old legacy secret! How to build a legacy brand?",
          "alt_text": "Ultra",
          "btnText": "Read More",
          "link": "https://www.youtube.com/embed/c5r-6osd-VM?si=HfeY5PJItBOtEJfg&autoplay=1&mute=1"
        },

        {
          "mediaType": "Press release",
          "image_url": "/assets/images/media/online/online-img-23.webp",
          "batch": "<span>Press release</span>",
          "title": "Shriram Group Launches Shriram Wealth, a Strategic 50:50 Joint Venture with Sanlam Group",
          "alt_text": "Shriram Group Launches Shriram Wealth, a Strategic 50:50 Joint Venture with Sanlam Group",
          "btnText": "Read More",
          "link": "/assets/images/pdf/press-release.pdf",
          "date": "22/06/2025"
        },


      ]
    }
  ];

  bannerContent: any = [
    {
      "title": "Media <u>Corner</u>",
      "sub_title": "<p>Enabling you to navigate your financial journey with confidence</p>",
      "image_url": "/assets/images/banners/media-banner.webp",
      "image_mob_url": "/assets/images/banners/media-banner-mobile.webp",
      "alt_text": "Media Corner",
      "class_name": ''
    }
  ];

  ngOnInit(): void {
    if (!this.metaDataSet) {
      let meta = {
        "title": "News & Media Updates | Shriram Wealth",
        "description": "Catch the latest news, updates, and media coverage about Shriram Wealth’s initiatives and industry presence.",
        "twitter_title": "News & Media Updates | Shriram Wealth",
        "twitter_description": "Catch the latest news, updates, and media coverage about Shriram Wealth’s initiatives and industry presence.",
        "og_title": "News & Media Updates | Shriram Wealth",
        "og_description": "Catch the latest news, updates, and media coverage about Shriram Wealth’s initiatives and industry presence.",
        "keywords": "shriram wealth, shriram wealth media corner"
      }
      this.title.setTitle(meta.title);
      this.meta.updateTag({ name: 'description', content: meta.description });
      this.meta.updateTag({ name: 'twitter:title', content: meta.twitter_title });
      this.meta.updateTag({ name: 'twitter:description', content: meta.twitter_description });
      this.meta.updateTag({ property: 'og:title', content: meta.og_title });
      this.meta.updateTag({ property: 'og:description', content: meta.og_description });
      this.meta.updateTag({ name: 'keywords', content: meta.keywords });



      const head = this.document.getElementsByTagName('head')[0];
      let element: HTMLLinkElement | null = this.document.querySelector(`link[rel='canonical']`);
      if (!element) {
        element = this.document.createElement('link') as HTMLLinkElement;
        head.appendChild(element);
      }
      element.setAttribute('rel', 'canonical');
      element.setAttribute('href', environment.appUrl + "media-corner");
      this.metaDataSet = true;
    }


    const jsonLdData =
    {
      "@context": "https://schema.org/",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": environment.appUrl
      }, {
        "@type": "ListItem",
        "position": 2,
        "name": "Media Corner",
        "item": environment.appUrl + "media-corner"
      }]
    };
    const scriptElement = this.renderer.createElement('script');
    this.renderer.setAttribute(scriptElement, 'type', 'application/ld+json');
    this.renderer.setProperty(scriptElement, 'innerHTML', JSON.stringify(jsonLdData));
    const existingScript = this.document.querySelector('script[type="application/ld+json"]');
    if (existingScript) {
      this.renderer.removeChild(this.document.head, existingScript);
    }
    this.renderer.appendChild(this.document.head, scriptElement);

  }
}
